import { getAppEnv } from './env';

export const DEFAULT_CLOUDFLARE_API_URL =
  'https://app.commit2act.org';

const PRODUCTION_APP_HOSTNAME = 'app.commit2act.org';

const getDefaultCloudflareApiUrl = () => {
  if (
    typeof window !== 'undefined' &&
    window.location?.hostname === PRODUCTION_APP_HOSTNAME
  ) {
    return window.location.origin;
  }

  return DEFAULT_CLOUDFLARE_API_URL;
};

export const getCloudflareApiBaseUrl = () =>
  getAppEnv('CLOUDFLARE_API_URL', getDefaultCloudflareApiUrl()).replace(/\/+$/, '');

export const buildCloudflareUrl = (path) => `${getCloudflareApiBaseUrl()}${path}`;
